import { connectRedux } from '@om1/platform-utils'
import { BackOfficeState } from '../state'
import { dataDeliveryActions } from '../state/data-delivery'
import { CreateEditDataDeliveryDialogComponent } from './CreateEditDataDeliveryDialogComponent'

export function createCreateEditDataDeliveryDialogComponent<TState extends { backOffice: BackOfficeState }>() {
    return connectRedux(
        CreateEditDataDeliveryDialogComponent,
        (state: TState) => ({
            cohorts: state.backOffice.dataDelivery.edit.cohorts,
            cohortsLoading: state.backOffice.dataDelivery.edit.ui.cohortsLoading,
            deliveredDatabases: state.backOffice.dataDelivery.edit.deliveredDatabases,
            deliveredDatabasesLoading: state.backOffice.dataDelivery.edit.ui.deliveredDatabasesLoading,
            isLoading: state.backOffice.dataDelivery.edit.ui.dataDeliveryLoading
        }),
        dataDeliveryActions
    )
}

export type CreateEditDataDeliveryDialog = ReturnType<typeof createCreateEditDataDeliveryDialogComponent>
